import Modal from "../elements/Modal";
import { lngDetect } from "../../helpers/lngDetect";

// Simple alternative component if you prefer external CSS
export const PrivacyModal = ({ isOpen, onClose, organizationData }) => {
  const cleanHTML = (htmlString) => {
    if (!htmlString) return "";
    return htmlString.replace(/>\s+</g, "><").replace(/\n\s*/g, "").trim();
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={onClose}
      title={"Privacy Policy"}
      size="xl4"
      titleIcon="fa-regular fa-paper-plane"
      titleClass="!font-semibold !text-2xl !capitalize truncate max-w-[700px] w-full tracking-tight !text-deep-purple"
      headerClass="!text-black !rounded-t-2xl border-b border-surface-03 bg-primary/10 py-4 px-10"
      childrenClasses="!bg-white"
      bodyClasses={"!py-6"}
    >
      <div className="text-base text-gray-700 space-y-3 max-h-[80vh] overflow-y-auto pr-2">
        <div
          className="tiptap-content"
          dangerouslySetInnerHTML={{
            __html: cleanHTML(lngDetect(organizationData?.setting?.privacy)),
          }}
        />
      </div>
    </Modal>
  );
};
